var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9615 0H4.03846C2.96739 0 1.9402 0.347199 1.18284 0.965216C0.42548 1.58323 0 2.42145 0 3.29545V25.7045C0 26.5786 0.42548 27.4168 1.18284 28.0348C1.9402 28.6528 2.96739 29 4.03846 29H16.9615C18.0326 29 19.0598 28.6528 19.8172 28.0348C20.5745 27.4168 21 26.5786 21 25.7045V3.29545C21 2.42145 20.5745 1.58323 19.8172 0.965216C19.0598 0.347199 18.0326 0 16.9615 0ZM10.5 27.6818C9.15923 27.6818 8.07692 26.7986 8.07692 25.7045C8.07692 24.6105 9.15923 23.7273 10.5 23.7273C11.8408 23.7273 12.9231 24.6105 12.9231 25.7045C12.9231 26.7986 11.8408 27.6818 10.5 27.6818ZM17.7692 22.4091H3.23077V3.95455H17.7692V22.4091Z",
    fill: "#013847"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.08c72fe2e8df40ac5655828a3e70aeef.svg";
export { ForwardRef as ReactComponent };